export const getStatusUpdateOptions = (currentStatus) => {
  if (currentStatus === "pending") return ["successful", "rejected"]
  if (currentStatus === "successful") return ["unenrolled"]
  return []
}
